export default __webpack_public_path__ + "static/soon-gift-e68d460073470b04735ac8bbf17f770e.svg";